import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
// import dateHelper from '@utils/dates';
// import tagHelper from '@utils/tagHelper';
import { Spacings, Fonts } from '@styles/index';
import { getIsLive } from '../scheduleHelper';
import ScheduleCard from '../ScheduleCard';

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  border-bottom: ${Spacings.SPACING_2} solid
    ${({ $hasLiveClass }) =>
      $hasLiveClass ? 'var(--color-i-red)' : 'var(--color-divider)'};
`;

const Time = styled.span`
  font-weight: ${Fonts.REGULAR};
  font-size: ${Fonts.H4};
  line-height: ${Fonts.HEADER_LINE_HEIGHT};
  color: ${({ $hasLiveClass }) =>
    $hasLiveClass ? 'var(--color-i-red)' : 'var(--color-i-violet-7)'};
  flex: 0 0 auto;
  width: 128px;
  position: sticky;
  top: 174px;
  padding: ${Spacings.SPACING_6B} ${Spacings.SPACING_0B};
  align-self: flex-start;
  margin-right: ${Spacings.SPACING_4B};
`;

const CardsContainer = styled.div`
  width: calc(100% - 144px);
  display: grid;
  grid-template: 1fr / ${({ $cols }) => `repeat(${$cols}, 1fr)`};
  grid-column-gap: ${Spacings.SPACING_4B};
`;

const StyledCard = styled(ScheduleCard)`
  ${({ $isLast }) =>
    !$isLast ? 'border-bottom: 2px dashed var(--color-divider);' : ''}
  padding: ${Spacings.SPACING_6B} ${Spacings.SPACING_0B};
  /* width: 336px; */
  grid-column-start: ${({ $gridStart }) => $gridStart};
`;

const ScheduleRow = ({ data, liveAt, dates }) => {
  const hasLiveClass = useMemo(() => {
    return dates.some((date) =>
      (data[date] || []).some((scheduledClass) => getIsLive(scheduledClass))
    );
  }, [data, dates]);
  const maxClassesCount = dates.reduce(
    (maxCount, date) => Math.max(data[date]?.length || 0, maxCount),
    0
  );
  return (
    <Wrapper $hasLiveClass={hasLiveClass}>
      <Time $hasLiveClass={hasLiveClass}>{liveAt}</Time>
      {new Array(maxClassesCount).fill(0).map((_, index) => {
        return (
          <CardsContainer
            key={String(`${liveAt}-${index}`)}
            $cols={dates.length}
          >
            {dates.map((date, i) => {
              const scheduledClass = data[date]?.[index];
              return scheduledClass ? (
                <StyledCard
                  key={scheduledClass.programme.uid}
                  data={scheduledClass}
                  $isLast={index === data[date].length - 1}
                  $gridStart={i + 1}
                />
              ) : null;
            })}
          </CardsContainer>
        );
      })}
    </Wrapper>
  );
};

ScheduleRow.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  liveAt: PropTypes.string.isRequired,
  dates: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default ScheduleRow;
